/* eslint-disable camelcase */
import replaceStateHistoryUtil from 'utils/history/replace-state'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import { omit } from 'lodash'
import getPathnameLocationUtil from 'utils/location/get-pathname'
import stringifyQueryObjectUtil from 'utils/object/stringify-query'
import getHashLocationUtil from 'utils/location/get-hash'
import {
  PRODUCT_QUERY_PARAMETER,
  PRODUCT_QUERY_PARAMETER_KEYS_TO_IGNORE
} from 'modules/product/constants'
import logUtil from 'utils/log'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'

const removeProductAndVariantIdFromUrlUtil = () => {
  const queryParameterKeysToIgnore = [...PRODUCT_QUERY_PARAMETER_KEYS_TO_IGNORE]

  if (!isMixedCollectionUrlLocationUtil()) {
    queryParameterKeysToIgnore.push(PRODUCT_QUERY_PARAMETER.COLLECTION_ID)
  }

  const queryParams = omit(
    getQueryParamsFromStringObjectUtil(),
    queryParameterKeysToIgnore
  )

  const url = getPathnameLocationUtil()
  const queryParamsStr = stringifyQueryObjectUtil(queryParams)
  const newUrl = `${url}${queryParamsStr ? `?${queryParamsStr}` : ''}${getHashLocationUtil()}`
  const debugProps = {
    url,
    queryParams,
    queryParamsStr,
    newUrl
  }

  logUtil('removeProductAndVariantIdFromUrlUtil').debug('[start] debugProps=', debugProps)
  replaceStateHistoryUtil(newUrl)
}

export default removeProductAndVariantIdFromUrlUtil
